import Component from './AccordionFade';
export default Component;

export const componentName = 'AccordionFade';
